/**
 * @generated SignedSource<<d32deed97154aba5ada3270c7fbc9eea>>
 * @relayHash f5a076439536871365b8225b9f8b1f65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5455220f49be0fe5fe19edc3c0c160830009b5230710c48290c7cbb71a2c4a86

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useIsEligibleForNthUserHomeOnboardingRevampLicensedUserCountQuery$variables = Record<PropertyKey, never>;
export type useIsEligibleForNthUserHomeOnboardingRevampLicensedUserCountQuery$data = {
  readonly license: {
    readonly licenseConsumingUserCount: number;
  } | null | undefined;
};
export type useIsEligibleForNthUserHomeOnboardingRevampLicensedUserCountQuery = {
  response: useIsEligibleForNthUserHomeOnboardingRevampLicensedUserCountQuery$data;
  variables: useIsEligibleForNthUserHomeOnboardingRevampLicensedUserCountQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "License",
    "kind": "LinkedField",
    "name": "license",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "licenseConsumingUserCount"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useIsEligibleForNthUserHomeOnboardingRevampLicensedUserCountQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIsEligibleForNthUserHomeOnboardingRevampLicensedUserCountQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f5a076439536871365b8225b9f8b1f65",
    "id": "5455220f49be0fe5fe19edc3c0c160830009b5230710c48290c7cbb71a2c4a86",
    "metadata": {},
    "name": "useIsEligibleForNthUserHomeOnboardingRevampLicensedUserCountQuery",
    "operationKind": "query",
    "text": "query useIsEligibleForNthUserHomeOnboardingRevampLicensedUserCountQuery{license{licenseConsumingUserCount}}"
  }
};
})();

(node as any).hash = "2ecca5de7b1ea52e69759dc5f66d5172";

export default node;
